import styled, { css } from 'styled-components';
import { combineValues } from '@clds/component-theme';
import { getLabelRatio, formTheme } from './theme';
export const LabelWrapper = styled.div ``;
export const InputAndValidationWrapper = styled.div ``;
export const CommonFieldLayout = styled.div `
  margin-bottom: ${formTheme.layout.margin.bottom};
  ${(props) => props.layout === 'horizontal' && horizontalBase};
`;
const horizontalBase = css `
  display: flex;
  & > ${LabelWrapper} {
    margin-right: ${formTheme.layout.gap};
    flex: ${combineValues(formTheme.label.ratio, (ratioConfig, props) => String(getLabelRatio(props.labelRatio, ratioConfig)))};
  }
  & > ${InputAndValidationWrapper} {
    flex: ${combineValues(formTheme.label.ratio, (ratioConfig, props) => String(1 - getLabelRatio(props.labelRatio, ratioConfig)))};
    min-width: 0;
    align-self: center;
  }
`;
//# sourceMappingURL=common.js.map